import colors from '../../themes/light';

export default {
    name: 'BaseIcon',
    props: {
        opacity: {
            type: Number,
            default: 1,
            validator: (opacity) => {
                if (opacity >= 0 && opacity <= 1) {
                    return true;
                }

                throw new Error('Opacity needs to be between 0 and 1');
            },
        },
        color: {
            type: String,
            require: false,
            validator: (color) => {
                if (!Object.prototype.hasOwnProperty.call(colors, color)) {
                    throw new Error(`Color with name ${color} was not found!`);
                }
                return true;
            },
        },
    },

    data() {
        return {
            defaultColor: '',
        };
    },

    computed: {
        colorHexCode() {
            return this.getColorCodeByName(this.color ? this.color : this.defaultColor);
        },
    },

    methods: {
        getColorCodeByName(colorName) {
            return colors[colorName];
        },
    },
};
